var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogsAndHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 19.4722C12.0615 20.4223 13.4633 21 15 21C18.3137 21 21 18.3137 21 15C21 12.2331 19.1271 9.90359 16.5798 9.21017M5.42018 9.21016C2.87293 9.90358 1 12.2331 1 15C1 18.3137 3.68629 21 7 21C10.3137 21 13 18.3137 13 15C13 14.2195 12.851 13.4738 12.5798 12.7898M17 7C17 10.3137 14.3137 13 11 13C7.68629 13 5 10.3137 5 7C5 3.68629 7.68629 1 11 1C14.3137 1 17 3.68629 17 7Z",
    stroke: "#000025",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogsAndHistory);
export default __webpack_public_path__ + "static/media/Logs-and-history.9e098b0c0840fab42e8c94e698a8b245.svg";
export { ForwardRef as ReactComponent };